<template>
  <div class="ticket-list">
  <v-card>
        <v-app-bar flat >
          <v-icon>mdi-ticket</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('ticket.tickets')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu left bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-if="userHasAccess('ticket_edit')"
                  @click="addHandler"
                >
                  <v-list-item-title>{{$t('global.add')}}</v-list-item-title>

                </v-list-item>

              </v-list>
            </v-menu>
        </v-app-bar>
      <v-card-text>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.id" slot-scope="{ item }">
            <span v-if="item.priority.intensity >= 300 ">
              <v-chip
                 class="ma-2"
                 color="error"
                 text-color="white"
               >
                 {{ item['id'] }}
               </v-chip>
            </span>
            <span v-else >
              <v-chip
                 class="ma-2"
               >
                 {{ item['id'] }}
               </v-chip>
            </span>
          </template>
          <template slot="item.created" slot-scope="{ item }">
            {{ formatDateTime(item['created'], 'long') }}
          </template>
          <template slot="item.tags" slot-scope="{ item }">
            <div id="tags">
            <v-chip v-for="tag in item['tags']" :key="tag.id"
              class="ma-1 font-weight-bold"

              color="secondary"
            >
              {{ tag.name }}
            </v-chip>
          </div>
          </template>
          <template slot="item.status" slot-scope="{ item }">
            <v-chip
              class="ma-1 font-weight-bold"
              label
              :color="statuscolor(item['status'])"
            >
              <v-icon left v-if="item['status'].init">
                mdi-new-box
              </v-icon>
              <v-icon left v-if="item['status'].finish">
                mdi-flag-checkered
              </v-icon>
              <v-icon left v-if="! item['status'].finish && ! item['status'].init">
                mdi-cached
              </v-icon>
              {{ item['status'].name }}
            </v-chip>
          </template>

          </v-data-table>
        </v-card-text>
      </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';

import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'TicketList',
  servicePrefix: 'Ticket',
  mixins: [ListMixin,AccessMixin],
  components: {


  },
  data() {
    return {
      headers: [
        { text: this.$t('ticket.number'), value: 'id' },
        { text: this.$t('ticket.ticketstatus'), value: 'status' },
        { text: this.$t('qualitycheck.product.customer'), value: 'customer.name' },
        { text: this.$t('global.date'), value: 'created' },
        { text: this.$t('global.title'), value: 'name' },
        { text: this.$t('ticket.bugtype'), value: 'bugType.name' },
        { text: this.$t('ticket.tags'), value: 'tags' },

      ],
      selected: [],
      filters: {

      },
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['status.finish','created'], sortDesc : [false,true]}
    };
  },
  computed: {
    ...mapGetters('ticket', {
      items: 'list'
    }),
    ...mapFields('ticket', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('ticket', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    statuscolor(status) {
      if (status.important) {
        return 'error';
      }
      if (status.init) {
        return 'primary';
      }
      if (status.finish) {
        return 'success';
      }
      return 'accent';
    }
  }
};
</script>
